{
  "AboutPage": {
    "get-listed-description": "क्या आप ट्रस्ट मार्केटप्लेस पर अपने व्यवसाय का प्रदर्शन करना चाहते हैं?",
    "get-listed-suffix": "प्रारंभ करना।",
    "get-listed-title": "सूचीबद्ध हों",
    "how-description": "व्यापारी और व्यक्ति Raytio प्लेटफॉर्म के माध्यम से अपनी पहचान, व्यवसाय पंजीकरण और प्रमाण पत्रों का सत्यापन करते हैं। प्रत्येक सत्यापन डिजिटल रूप से हस्ताक्षरित और स्वतंत्र रूप से ऑडिट योग्य होता है, जिससे विश्वास की एक पारदर्शी श्रृंखला सुनिश्चित होती है।",
    "how-title": "सत्यापन कैसे काम करता है",
    "sign-up": "Raytio के लिए साइन अप करें",
    "title": "ट्रस्ट मार्केटप्लेस के बारे में",
    "what-is-description": "रेयटियो ट्रस्ट मार्केटप्लेस सत्यापित व्यापारियों और सेवा प्रदाताओं की एक सार्वजनिक निर्देशिका है। प्रत्येक सूची क्रिप्टोग्राफिक सत्यापन द्वारा समर्थित है, जो यह सुनिश्चित करता है कि आपको दिखाई देने वाली जानकारी प्रामाणिक और विश्वसनीय है।",
    "what-is-title": "ट्रस्ट मार्केटप्लेस क्या है?"
  },
  "BookingPage": {
    "book": "किताब",
    "date-range-label": "अगला",
    "days-label": "दिन",
    "km-away": "{दूरी} किमी दूर",
    "location-label": "जगह",
    "location-placeholder": "उपनगर या शहर दर्ज करें...",
    "no-results": "कोई अपॉइंटमेंट उपलब्ध नहीं है। कृपया अपनी खोज का दायरा या दिनांक सीमा बढ़ाएँ।",
    "progress": "खोज {पूर्ण} प्रदाताओं में से {कुल} प्रदाताओं की खोज की गई",
    "radius-label": "अंदर",
    "search": "खोज",
    "search-failed": "खोज विफल रही। कृपया पुनः प्रयास करें।",
    "search-timed-out": "खोज का समय समाप्त हो गया। कुछ प्रदाताओं ने शायद जवाब नहीं दिया हो।",
    "searching": "सेवा प्रदाताओं की खोज की जा रही है...",
    "service-label": "सेवा",
    "service-placeholder": "एक सेवा का चयन करें...",
    "sign-in-prompt": "उपलब्ध अपॉइंटमेंट खोजने के लिए अपने Raytio खाते से साइन इन करें।",
    "sign-in-to-search": "खोज करने के लिए लॉग इन करें",
    "sort-closest": "निकटतम",
    "sort-provider": "प्रदाता द्वारा",
    "sort-soonest": "जल्द से जल्द",
    "title": "अपॉइंटमेंट बुक करें",
    "location-permission-denied": "स्थान की अनुमति अस्वीकार कर दी गई। कृपया इसके बजाय एक पता दर्ज करें।",
    "location-unavailable": "आपका स्थान निर्धारित नहीं किया जा सका। कृपया इसके बजाय एक पता दर्ज करें।",
    "my-location": "मेरा स्थान",
    "use-my-location": "मेरे स्थान का उपयोग करें",
    "sign-up-prompt": "क्या आपके पास खाता नहीं है? उपलब्ध अपॉइंटमेंट खोजने के लिए साइन अप करें।",
    "sign-up-to-search": "खोजने के लिए साइन अप करें",
    "view-list": "List",
    "view-calendar": "Calendar"
  },
  "CategoryFilter": {
    "clear": "Clear",
    "no-results": "No categories found",
    "placeholder": "Filter by category…"
  },
  "CountryFilter": {
    "all-countries": "सभी देश",
    "filter-by-country": "देश के अनुसार फ़िल्टर करें"
  },
  "CtaBar": {
    "book": "किताब",
    "coming-soon": "जल्द आ रहा है"
  },
  "Footer": {
    "about": "के बारे में",
    "powered-by": "द्वारा संचालित",
    "privacy": "गोपनीयता",
    "terms": "शर्तें"
  },
  "Header": {
    "about": "के बारे में",
    "brand": "रेयटियो मार्केटप्लेस",
    "merchants": "व्यापारियों",
    "services": "सेवाएं",
    "sign-in": "दाखिल करना",
    "sign-out": "साइन आउट",
    "sign-up": "साइन अप करें"
  },
  "HomePage": {
    "subtitle": "प्रमाणित व्यापारियों और भरोसेमंद सेवा प्रदाताओं को खोजें।",
    "title": "ट्रस्ट मार्केटप्लेस",
    "verified-merchants": "सत्यापित व्यापारी",
    "view-all": "सभी को देखें"
  },
  "MerchantCard": {
    "unnamed": "अनाम व्यापारी",
    "verified": "सत्यापित"
  },
  "MerchantDetail": {
    "active": "सक्रिय",
    "approved": "अनुमत",
    "default-description": "इस व्यापारी को Raytio Trust Marketplace पर देखें।",
    "forms-heading": "फार्म",
    "forms-sign-in-button": "फॉर्म देखने के लिए लॉग इन करें",
    "forms-sign-in-prompt": "इस व्यापारी के फॉर्म देखने के लिए अपने Raytio खाते से साइन इन करें।",
    "locations": "स्थानों",
    "no-address": "कोई पता उपलब्ध नहीं है",
    "no-forms-available": "कोई प्रपत्र उपलब्ध नहीं हैं",
    "not-found": "व्यापारी नहीं मिला",
    "primary-use": "प्राथमिक",
    "sign-in-prompt": "इस व्यापारी की शाखाओं और स्थानों की जानकारी देखने के लिए अपने Raytio खाते से लॉग इन करें।",
    "sign-in-to-view": "स्थानों को देखने के लिए लॉग इन करें",
    "unnamed": "अनाम व्यापारी",
    "forms-sign-up-button": "फ़ॉर्म देखने के लिए साइन अप करें",
    "forms-sign-up-prompt": "क्या आपके पास खाता नहीं है? इस व्यापारी के फ़ॉर्म देखने के लिए साइन अप करें।"
  },
  "MerchantsPage": {
    "no-merchants": "कोई व्यापारी नहीं मिला।",
    "subtitle": "सत्यापित व्यापारियों और विश्वसनीय सेवा प्रदाताओं को ब्राउज़ करें।",
    "title": "व्यापारी निर्देशिका"
  },
  "SearchBar": {
    "placeholder": "व्यापारियों को खोजें..."
  },
  "ServiceCategoryFilter": {
    "no-results": "कोई श्रेणियां नहीं मिलीं",
    "placeholder": "किसी सेवा श्रेणी पर जाएं…"
  },
  "ServiceCategoryPage": {
    "breadcrumb-services": "सेवाएं",
    "no-merchants": "इस सेवा के लिए कोई प्रदाता नहीं मिला।",
    "not-found": "सेवा नहीं मिली",
    "search-placeholder": "खोज प्रदाता...",
    "sign-in-prompt": "इस सेवा के प्रदाताओं को देखने के लिए अपने Raytio खाते से साइन इन करें।",
    "sign-in-to-view": "सेवा प्रदाताओं को देखने के लिए साइन इन करें",
    "sign-up-prompt": "क्या आपके पास खाता नहीं है? इस सेवा के प्रदाताओं को देखने के लिए साइन अप करें।",
    "sign-up-to-view": "प्रदाताओं को देखने के लिए साइन अप करें"
  },
  "ServiceItemAttributes": {
    "no-data": "कोई विशेषता डेटा उपलब्ध नहीं है।"
  },
  "ServiceMerchantPage": {
    "breadcrumb-services": "सेवाएं",
    "hide-details": "विवरण छुपाओ",
    "items-title": "उत्पाद और सेवाएं",
    "no-items": "यहां कोई उत्पाद या सेवा सूचीबद्ध नहीं है।",
    "not-found": "नहीं मिला",
    "show-details": "प्रदर्शन का विवरण"
  },
  "ServicesPage": {
    "no-services": "कोई सेवा उपलब्ध नहीं है।",
    "services-count": "{count, plural, one {# सेवा} other {# सेवाएं}}",
    "subtitle": "श्रेणी के अनुसार सेवाओं को ब्राउज़ करें।",
    "title": "सेवाएं"
  },
  "ThemeToggle": {
    "dark-mode": "डार्क मोड पर स्विच करें",
    "light-mode": "लाइट मोड पर स्विच करें"
  },
  "Persona": {
    "issued": "Issued",
    "expires": "Expires",
    "last-verified": "Last verified",
    "self-asserted-note": "Name and bio are self-asserted and unverified",
    "profile-url": "Profile",
    "claim-verification": "Verification",
    "claim-reputation": "Reputation",
    "section-verifications": "Verifications",
    "section-social": "Connected Accounts",
    "section-reputation": "Reputation",
    "section-other": "Other Claims",
    "no-claims": "This profile has no published claims yet.",
    "rating": "Rating",
    "activity": "Activity",
    "member-since": "Member since",
    "not-found-title": "Profile Not Found",
    "not-found-description": "The requested profile could not be found.",
    "canonical-payload": "हस्ताक्षरित डेटा",
    "signature": "हस्ताक्षर",
    "signing-key": "हस्ताक्षर कुंजी",
    "verify": "हस्ताक्षर सत्यापित करें",
    "verifying": "सत्यापित किया जा रहा है…",
    "verify-valid": "हस्ताक्षर मान्य है",
    "verify-invalid": "हस्ताक्षर मेल नहीं खाता",
    "verify-no-key": "कोई हस्ताक्षर कुंजी दर्ज नहीं — सत्यापन संभव नहीं",
    "verify-error": "हस्ताक्षर कुंजी प्राप्त नहीं की जा सकी",
    "signed": "Signed",
    "verified": "Verified",
    "view-signed-data": "View signed data",
    "hide-signed-data": "Hide signed data",
    "verify-again": "Verify again",
    "try-again": "Try again",
    "verify-valid-detail": "Checked in your browser against Raytio's published key.",
    "verify-valid-caveat": "A valid signature proves Raytio asserted this — not that it is true or complete.",
    "verify-invalid-detail": "This claim may have been altered.",
    "trust-note": "Each signed claim below carries an RSA-PSS signature from Raytio. Expand one to read the exact bytes that were signed and check them in your own browser — you don't have to take this page's word for anything.",
    "attested-claims-title": "Attested claims",
    "claims-summary": "{count, plural, one {# signed by Raytio · check it yourself} other {# signed by Raytio · check any of them yourself}}",
    "open-profile": "Open profile",
    "trust-note-label": "About attested claims",
    "reputation-note": "Bucketed on purpose — Raytio never publishes exact counts.",
    "stat-activity": "Activity",
    "stat-as-buyer": "As buyer",
    "stat-as-seller": "As seller",
    "stat-reviews": "Reviews",
    "stat-none-yet": "None yet",
    "reputation-note-label": "About these figures"
  },
  "Calendar": {
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "all": "All",
    "book": "Book",
    "close": "Close",
    "move": "Move detail window",
    "move-reset": "Move detail window (double-click to snap back)",
    "no-slots-day": "No available slots for this day.",
    "more-slots": "+{count} more",
    "slot-count": "{count, plural, one {# slot} other {# slots}}"
  },
  "BuyPage": {
    "title": "अपना सत्र चुनें",
    "slot-label": "स्लॉट {slotNumber}",
    "choose-duration": "अवधि चुनें",
    "in-use-title": "यह स्लॉट उपयोग में है",
    "in-use-body": "इस स्लॉट में अभी एक सक्रिय सत्र है। कृपया कुछ देर बाद फिर से देखें।",
    "halted-title": "खरीद जारी है",
    "halted-body": "कोई इस स्लॉट के लिए खरीद पूरी कर रहा है। कृपया एक क्षण प्रतीक्षा करें और फिर से प्रयास करें।",
    "no-options": "इस स्लॉट के लिए कोई विकल्प उपलब्ध नहीं है।"
  }
}
